import React from "react";
import Accordion from "react-bootstrap/Accordion";

const FAQs = () => {
  const faqsData = [
{

  question: "Jak długo trwa realizacja filmu?",

  answer:

    "Czas realizacji zależy od rodzaju materiału i zakresu prac. Proste materiały mogą być gotowe w kilka dni, natomiast bardziej rozbudowane produkcje wymagają więcej czasu na przygotowanie, nagrania i montaż.",

},
{

  question: "Ile czasu trwa dzień zdjęciowy?",

  answer:

    "To zależy od rodzaju materiału. Krótkie nagrania contentowe często realizuję w 1-2 godziny, natomiast bardziej rozbudowane filmy reklamowe mogą wymagać kilku godzin lub całego dnia. Przed realizacją zawsze ustalam orientacyjny harmonogram."

},
{
  question: "Czy muszę występować przed kamerą?",
  answer:
    "Nie. Wszystko zależy od charakteru materiału i Twoich preferencji. Jeśli nie chcesz pojawiać się w kadrze, przygotuję film oparty na ujęciach produktów, wnętrza lub procesu pracy. Jeśli zdecydujesz się wystąpić, pomogę Ci podczas nagrań i zadbam o to, aby wszystko wyglądało naturalnie."
},

{

  question: "Czy muszę przygotować miejsce i wszystko zorganizować przed nagraniami?",

  answer:

    "Nie musisz zajmować się stroną techniczną. Przed realizacją omawiamy najważniejsze szczegóły, a ja podpowiadam, jak przygotować przestrzeń, ludzi oraz przebieg nagrań, aby efekt końcowy wyglądał profesjonalnie.",

},

{
  question: "Czy nagrywasz tylko firmy, czy również osoby prywatne?",
  answer:
    "Współpracuję zarówno z firmami, jak i osobami prywatnymi rozwijającymi markę osobistą. Jeśli tworzysz treści w social mediach, budujesz swój wizerunek eksperta lub chcesz profesjonalnie zaprezentować swoją działalność, przygotuję materiały dopasowane do Twoich celów."
},





{

  question: "Czy realizujesz nagrania w mojej okolicy?",

  answer:

    "Tak. Działam głównie na terenie Starogardu Gdańskiego i okolic, ale jestem otwarty również na realizacje w innych lokalizacjach po wcześniejszym ustaleniu szczegółów.",

},
  ];

  return (
    <section id="faq" className="section">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-6 order-1 order-lg-0 wow fadeInUp">
            {/* Heading */}
            <p className="text-center text-lg-start mb-2">
              <span className="bg-primary text-dark px-2">FAQ</span>
            </p>
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">
              Najczęściej zadawane pytania:
            </h2>
            {/* Heading end*/}

            <Accordion flush defaultActiveKey="0">
              {faqsData.length > 0 &&
                faqsData.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    ></Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-0 order-lg-1 wow fadeIn"
            data-wow-delay="1s"
          >
            {" "}
            <img
              className="img-fluid"
              src="images/faq.png"
              title="FAQ"
              alt="faq"
            />{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
